module.exports = __webpack_public_path__ + "static/img/image3.d02af8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/image3.png
// module id = 0vLf
// module chunks = 0